import "./register.component.scss";
import LOGO from "../../assets/images/logo-interview-ai.png"
import { useFilePicker } from "use-file-picker";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";
import UPLOAD_FILE from "../../assets/images/upload-file.png";
import { Autocomplete, Checkbox, FormControl, FormControlLabel, InputLabel, MenuItem, Radio, RadioGroup, Select, TextField } from "@mui/material";
import ScoutConnectService from "../../services/hr9/hr9.services";
import { CompanyIndustryModel } from "../../model/company-industry.model";
import LocationPicker from "../../shared/location-picker/location-picker.shared";
import config from "../../config";
import { CompanyRegisterModel } from "../../model/company-register.model";
import { IndustryModel } from "../../model/industry.model";
import { useNavigate, useParams } from "react-router-dom";
import { createCompany } from "../../services/api.service";
import storage from "../../utils/storage";
import tokenService from "../../services/token.service";
import AuthenMysa from "../../services/authen/mysa.authen";
const RegisterComponent = () => {
    const { company_id } = useParams<{ company_id: string }>();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [fileUpload, setFileUpload] = useState<File | null>(null);
    const [allIndustry, setAllIndustry] = useState<IndustryModel[]>([]);
    const [industryList, setIndustryList] = useState<String[]>([]);
    const [isIndustryValid, setIsIndustryValid] = useState(false);
    const navigate = useNavigate();
    const [addressValue, setAddressValue] = useState("");
    const [isConsent, setIsConsent] = useState(false);
    const [latitude, setLatitude] = useState(0);
    const [isValidIDNumber, setIsValidIDNumber] = useState(false);
    const [isValidPhone, setIsValidPhone] = useState(false);
    const [longitude, setLongitude] = useState(0)
    const [formList, setFormList] = useState([
        { label: "ชื่อบริษัท", field: "company_name", value: "", is_require: true, is_error: true, error_message: "กรุณากรอก" },
        { label: "ประเภทอุตสาหกรรม", field: "company_industry", value: "", is_require: true, is_error: true, error_message: "กรุณากรอก" },
        { label: "ขนาดของบริษัท", field: "company_size", value: "", is_require: true, is_error: true, error_message: "กรุณากรอก" },
        { label: "ประเภทธุรกิจ", field: "company_type", value: "", is_require: true, is_error: true, error_message: "กรุณาเลือก" },
        { label: "รายละเอียดบริษัท", field: "company_detail", value: "", is_require: false, is_error: true, error_message: "กรุณากรอก" },
        { label: "เลขประจำตัวผู้เสียภาษี", field: "id_number", value: "", is_require: false, is_error: true, error_message: "กรุณากรอก" },
        { label: "เบอร์โทรศัพท์", field: "company_phone", value: "", is_require: true, is_error: true, error_message: "กรุณากรอก" },
        { label: "ที่อยู่", field: "company_address", value: "", is_require: true, is_error: true, error_message: "กรุณากรอก}" }

    ])
    const { openFilePicker } = useFilePicker({
        multiple: false,
        readAs: 'DataURL',
        accept: ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf', '.doc', ".docx"],
        limitFilesConfig: { min: 0, max: 1 },
        maxFileSize: 20,
        onFilesSelected: ({ plainFiles }) => {
            setFileUpload(plainFiles[0]);
        }
    });

    useEffect(() => {

        getIndustryList();
    }, [])
    const removeFile = () => {
        setFileUpload(null);
    }

    const handleInputChange = (event: any, field: string, index) => {
        let value = "";
        if (field == "company_industry") {
            console.log(event);
            const isValid = industryList.filter((item) => item === event);
            console.log(isValid);
            if (isValid.length > 0) {
                console.log(false);
                setIsIndustryValid(false);
            } else {
                console.log(true);
                setIsIndustryValid(true);
            }

            value = event;
        } else if (field == "company_type") {
            value = event;
        }
        else {
            value = event.target.value;
        }
        if (formList) {

            const formListMod = [...formList];
            if (field == "id_number") {
              
                if (isSubmitting && isValidThaiId(formListMod[5].value)) {
                    setIsValidIDNumber(true)
                } else if (isSubmitting && !isValidThaiId(formListMod[5].value)) {
                    setIsValidIDNumber(false);
                }
            }
            if(field == "company_phone"){
                console.log(event.target.value);
                if (isSubmitting && isValidPhoneNumber(event.target.value)) {
                    setIsValidPhone(true)
                } else if (isSubmitting && !isValidPhoneNumber(event.target.value)) {
                    setIsValidPhone(false);
                }
            }
            formListMod[index].value = value;
            formListMod[index].is_error = false;
            formListMod[index].error_message = "";
            setFormList(formListMod);
        }

    };

    useEffect(() => {
        if (company_id) {

        } else {
            alert("ไม่พบ id")
        }
    }, [company_id])
    const getIndustryList = () => {
        ScoutConnectService.getIndustry().then((res) => {
            console.log(res);
            if (res.data) {
                const result = res.data as IndustryModel[];
                setAllIndustry(result);
                const industryString = result.map(item => item.nameTh);
                setIndustryList(industryString as String[]);
            }
        })
    }

    const handleLocationChange = (lat: number, lng: number) => {
        setLatitude(lat);
        setLongitude(lng);

    };

    const submit = () => {
        setIsSubmitting(true);
        const isFormValid = validateForm();
        const phoneStatus = isValidPhoneNumber(formList[6].value);
        const idStatus = isValidPhoneNumber(formList[5].value);
        if(!idStatus){
            setIsValidIDNumber(true);
        }
        if(!phoneStatus) {
            setIsValidPhone(true);
        }

        if (isFormValid && isConsent && fileUpload && isValidPhone && isValidIDNumber) {

            const isIndustry = allIndustry.filter((item) => item.nameTh == formList[1].value);
            const companyType = Boolean(formList[3].value);
            let industryValue = 0;
            if (isIndustry.length > 0) {
                industryValue = isIndustry[0].id;
            }

            if (companyType) {
                if (formList[5].value) {
                    if (formList[5].value) {
                        const body: CompanyRegisterModel = {
                            name: formList[0].value,
                            websiteUrl: "",
                            industryId: industryValue,
                            companySize: formList[2].value,
                            corporate: Boolean(formList[3].value),
                            taxId: formList[5].value,
                            phone: formList[6].value,
                            address: addressValue,
                            latitude: latitude,
                            longitude: longitude,
                            logoImage: fileUpload,
                            careerPageUrl: formList[0].value
                        }
                        console.log(body);
                        // Check profile before submitting
                        AuthenMysa().getProfile().then((profileResult) => {
                            if (profileResult && profileResult.data) {
                                ScoutConnectService.submitCompanyApproval(convertToFormData(body)).then((res) => {
                                    if (res) {
                                        createCompany(company_id).then((res) => {
                                            if (res.data.is_success) {
                                                localStorage.setItem(storage.company_uuid, company_id + "");
                                                tokenService.setHR9CompanyUUID(company_id);
                                                navigate("/" + company_id + "/job-questions-list");
                                                console.log("Form submitted successfully!");
                                            }
                                        })
                                    }
                                })
                            } else {
                                // Invalid profile, redirect to login
                                navigate("/login");
                            }
                        }).catch((err) => {
                            // Error getting profile (including 401), redirect to login
                            console.log("Profile error:", err);
                            navigate("/login");
                        })
                    }

                } else {
                    const formListMod = [...formList];
                    formListMod[5].is_error = true;
                    formListMod[5].error_message = "กรุณากรอก";
                    setFormList(formListMod);
                }

            } else {
                if (formList[4].value) {
                    const body: CompanyRegisterModel = {
                        name: formList[0].value,
                        websiteUrl: "",
                        industryId: industryValue,
                        companySize: formList[2].value,
                        corporate: Boolean(formList[3].value),
                        description: formList[4].value,
                        phone: formList[6].value,
                        address: addressValue,
                        latitude: latitude,
                        longitude: longitude,
                        logoImage: fileUpload,
                        careerPageUrl: formList[0].value
                    }
                    console.log(body);
                    // Check profile before submitting
                    AuthenMysa().getProfile().then((profileResult) => {
                        if (profileResult && profileResult.data) {
                            ScoutConnectService.submitCompanyApproval(convertToFormData(body)).then((res) => {
                                if (res) {
                                    createCompany(company_id).then((res) => {
                                        if (res.data.is_success) {
                                            localStorage.setItem(storage.company_uuid, company_id + "");
                                            tokenService.setHR9CompanyUUID(company_id);
                                            navigate("/" + company_id + "/job-questions-list");
                                            console.log("Form submitted successfully!");
                                        }
                                    })
                                }
                            })
                        } else {
                            // Invalid profile, redirect to login
                            navigate("/login");
                        }
                    }).catch((err) => {
                        // Error getting profile (including 401), redirect to login
                        console.log("Profile error:", err);
                        navigate("/login");
                    })
                } else {
                    alert("Fill description")
                    const formListMod = [...formList];
                    formListMod[4].is_error = true;
                    formListMod[4].error_message = "กรุณากรอก";
                    setFormList(formListMod);
                }
            }

            setIsSubmitting(false);
            // ✅ Proceed with form submission

        } else {
            console.log(formList);
            // ❌ Show errors on form
            console.log("Please fill all required fields.");
        }
    }
    const isValidThaiId = (id: string): boolean => {
        if (!id || id.length !== 12 || !/^\d{12}$/.test(id)) {
            return false;
        } else {
            return true;
        }
    };
    const isValidPhoneNumber = (phone: string): boolean => {
        console.log(phone.length);
        if(phone.length > 8 && phone.length < 11){
            return true;
        }else{
            return false;
        }
    };
    const convertToFormData = (data: CompanyRegisterModel): FormData => {
        const formData = new FormData();

        formData.append('name', data.name);
        formData.append('careerPageUrl', data.careerPageUrl);
        formData.append('industryId', String(data.industryId));
        formData.append('companySize', data.companySize);
        formData.append('corporate', String(data.corporate));
        formData.append('phone', data.phone);
        formData.append('address', data.address);
        formData.append('latitude', String(data.latitude));
        formData.append('longitude', String(data.longitude));

        if (data.websiteUrl) {
            formData.append('websiteUrl', data.websiteUrl);
        }

        if (data.taxId) {
            formData.append('taxId', data.taxId);
        }

        if (data.description) {
            formData.append('description', data.description);
        }

        if (data.logoImage) {
            // If it's a File or Blob, append it directly
            formData.append('logoImage', data.logoImage as Blob);
        }

        return formData;
    };
    const validateForm = () => {
        let isValid = true;

        const updatedFormList = formList.map((item) => {
            const isRequired = item.is_require;
            const hasValue = item.value !== null && item.value !== undefined && item.value !== '';

            const isError = isRequired && !hasValue;

            if (isError) {
                isValid = false;
            }

            return {
                ...item,
                is_error: isError,
            };
        });

        setFormList(updatedFormList);
        return isValid;
    };

    const handleAddressChange = (address) => {
        console.log(address);
        setAddressValue(address);

    }

    useEffect(() => {
        if (addressValue) {
            if (formList) {
                const formMod = [...formList];
                formMod[7].value = addressValue;
                formMod[7].is_error = false;
                setFormList(formMod);
            }
        }
    }, [addressValue])
    return (
        <>
            <div className="register-control">
                <img src={LOGO} className="register-header-control"></img>
                <div className="border-std register-section-control">
                    <span className="header">กรอกข้อมูลบริษัทเพื่อลงทะเบียนใช้งาน Interview AI</span>
                </div>
                <div className="border-std register-section-control">
                    <div className="topic-control">
                        <div className="icon"></div>
                        <span className="text">อัปโหลดโลโก้บริษัท</span>
                    </div>

                    {
                        (fileUpload) ?
                            <div className="form-upload-file-control">
                                <img src={URL.createObjectURL(fileUpload)} className="upload-img"></img>
                                <div className="form-upload-text-control">
                                    <span className="form-upload-text">{fileUpload.name}</span>
                                </div>
                                <FontAwesomeIcon icon={faTrash} className="form-upload-trash"
                                    onClick={removeFile}></FontAwesomeIcon>
                            </div> :
                            <div className={isSubmitting && !fileUpload ? "form-upload-file-control form-upload-file-control-error" : "form-upload-file-control"}>
                                <img src={UPLOAD_FILE} className="upload-img"></img>
                                <div className="form-upload-text-control">
                                    <span className="form-upload-text">คลิกอัปโหลดเพื่อเพิ่มไฟล์</span>
                                    <span className="form-upload-desc">ไฟล์ที่รองรับ: .pdf, .doc, .docx, .xlxs | ขนาดไม่เกิน 25MB</span>
                                </div>
                                <Button className="form-upload-button" onClick={openFilePicker}>อัปโหลดโลโก้บริษัท</Button>
                            </div>
                    }
                </div>

                <div className="border-std register-section-control">
                    <div className="topic-control">
                        <div className="icon"></div>
                        <span className="text">รายละเอียดข้อมูลบริษัท</span>
                    </div>
                    <div className="form-input-control">
                        <FormControl
                            className={`input-std${isSubmitting && formList[0].is_error ? " input-error" : ""}`}
                            fullWidth
                        >
                            <TextField
                                id={`input-${0}`}
                                label={formList[0].label}
                                variant="outlined"
                                value={formList[0].value}
                                onChange={(e) => handleInputChange(e, formList[0].field, 0)}
                            />
                        </FormControl>
                    </div>
                    <div className="item-grid-control">

                        {industryList && industryList.length > 0 && (

                            <Autocomplete
                                id="free-solo-demo"
                                onInputChange={(event, value) => handleInputChange(value, formList[1].field, 1)}
                                className={`input-std${isSubmitting && formList[2].is_error ? " input-error" : isIndustryValid ? " input-error" : ""}`}
                                options={industryList}
                                value={formList[1].value}
                                renderOption={(props, option) => (
                                    <li {...props} className="autocomplete-option-custom">
                                        {option}
                                    </li>
                                )}
                                renderInput={(params) => <TextField {...params} label={formList[1].label} />}
                            />

                        )}

                        <FormControl className={`input-std${isSubmitting && formList[2].is_error ? " input-error" : ""}`} fullWidth>
                            <InputLabel id="demo-simple-select-label">{formList[2].label}</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={formList[2].value}
                                label="Job Employment"
                                onChange={(e) => handleInputChange(e, formList[2].field, 2)}
                            >
                                <MenuItem value="B">1 - 10 คน</MenuItem>
                                <MenuItem value="C">11 - 50 คน</MenuItem>
                                <MenuItem value="D">51 - 200 คน</MenuItem>
                                <MenuItem value="E">201 - 500 คน</MenuItem>
                                <MenuItem value="F">501 - 1,000 คน</MenuItem>
                                <MenuItem value="G">1,001 - 5,000 คน</MenuItem>
                                <MenuItem value="H">5,001 - 10,000 คน</MenuItem>
                                <MenuItem value="I">มากกว่า 10,000 คน</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <div className="form-input-control">
                        <span className="item-topic">ประเภทธุรกิจ</span>

                        <RadioGroup>
                            <div className="item-grid-control">
                                <FormControlLabel
                                    className="item-radio"
                                    value={true}
                                    onChange={() => handleInputChange(true, formList[3].field, 3)}
                                    control={<Radio sx={{ color: 'gray', '&.Mui-checked': { color: '#000' } }} />}
                                    label="นิติบุคคล"
                                />
                                <FormControlLabel
                                    className="item-radio"
                                    value={false}
                                    onChange={() => handleInputChange(false, formList[3].field, 3)}
                                    control={<Radio sx={{ color: 'gray', '&.Mui-checked': { color: '#000' } }} />}
                                    label="บุคคลธรรมดา"
                                />
                                {
                                    isSubmitting && formList[3].is_error && <span className="error-message">*กรุณาเลือกประเภทธุรกิจ</span>
                                }
                            </div>

                        </RadioGroup>


                    </div>
                    {
                        formList[3].value ?
                            <div className="form-input-control">
                                <FormControl
                                    className={`input-std${isSubmitting && formList[5].is_error ? " input-error": 
                                        isSubmitting && !isValidIDNumber ? " input-error" : ""}`}
                                    fullWidth
                                >
                                    <TextField
                                        id={`input-${5}`}
                                        label={formList[5].label}
                                        variant="outlined"
                                        type="number"
                                        value={formList[5].value}
                                        onChange={(e) => handleInputChange(e, formList[5].field, 5)}
                                    />
                                </FormControl>
                                {
                                    isSubmitting && !isValidIDNumber && <span className="error-message">*กรุณากรอกเลขประจำตัวประชาชนให้ถูกต้อง</span>
                                }

                            </div> :
                            <div className="form-input-control">
                                <FormControl
                                    className={`input-std${isSubmitting && formList[4].is_error ? " form-textarea input-error" : " form-textarea"}`}
                                    fullWidth
                                >
                                    <TextField
                                        id={`input-${4}`}
                                        label={formList[4].label}
                                        variant="outlined"
                                        multiline
                                        rows={4}
                                        value={formList[4].value}
                                        onChange={(e) => handleInputChange(e, formList[4].field, 4)}
                                    />
                                </FormControl>
                            </div>
                    }

                    <div className="form-input-control">
                        <FormControl
                            className={`input-std${isSubmitting && formList[6].is_error ? " input-error" : 
                                isSubmitting && !isValidPhone ? " input-error" : ""}`}
                            fullWidth
                        >
                            <TextField
                                id={`input-${6}`}
                                label={formList[6].label}
                                variant="outlined"
                                type="number"
                                value={formList[6].value}
                                onChange={(e) => handleInputChange(e, formList[6].field, 6)}
                            />
                        </FormControl>
                        {
                           isSubmitting && !isValidPhone && <span className="error-message">*กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง</span>
                        }
                    </div>

                    <div className="form-input-control">
                        <LocationPicker
                            isSubmit={isSubmitting}
                            formList={formList[7]}
                            handleAddressChange={handleAddressChange}
                            apiKey={config.google_api_key || ""}
                            onLocationChange={handleLocationChange}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={isConsent}
                                    onChange={(e) => setIsConsent(e.target.checked)}
                                    className="checkbox-custom"
                                    sx={{
                                        borderRadius: "6px", // Add border-radius
                                        "& .MuiSvgIcon-root": {
                                            borderRadius: "6px", // Apply border-radius inside the icon
                                            border: `1px solid ${isConsent ? "#4A25E1" : "#4A25E1"}`, // Border color logic
                                            backgroundColor: isConsent ? "#4A25E1" : "transparent", // Optional background color
                                        },
                                    }}
                                />
                            }
                            label={
                                <span className="text-checkbox-label">ฉันในฐานะตัวแทนบริษัทยอมรับ <a href="" className="link-purple">ข้อกำหนดและเงื่อนไขการใช้งาน</a> และ <a href="" className="link-purple">นโยบายความเป็นส่วนตัว</a></span>
                            }
                        />
                    </div>

                    <Button className="button-std button-submit" onClick={submit}>ส่งข้อมูลบริษัท</Button>

                </div>

            </div>
        </>
    )
}

export default RegisterComponent;